import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "../about.css";

export default function AboutPage() {
  useEffect(() => {
    AOS.init({ duration: 900, easing: "ease-out" });
  }, []);

  return (
    <div className="about-wrapper-vm">
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        className="about-hero-vm"
      >
        <h1>About Us</h1>
        <p>We're more than a story — we're a journey</p>
      </motion.div>

      <section className="about-section-vm">
        <motion.img
        //   src="https://images.unsplash.com/photo-1556761175-4b46a572b786"
          src="https://images.unsplash.com/photo-1521316730702-829a8e30dfd0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TWlzc2lvbnxlbnwwfHwwfHx8MA%3D%3D"
          alt="team"
          data-aos="fade-right"
        />

        <motion.div className="about-text-vm" data-aos="fade-left">
          <h2>Our Mission</h2>
          <p>
            Our mission is to turn curiosity into capability and ambition into achievement. At Acadme, we blend knowledge, technology, and real-world experience to create learning that feels alive—practical, powerful, and full of possibility. We exist to help students uncover their strengths, build future-ready skills, and step confidently into a world that demands innovation, adaptability, and growth. With every click, we aim to open new doors, spark new ideas, and shape careers that truly matter.
          </p>
        </motion.div>
      </section>

      <section className="about-section-vm reverse">
        <motion.img
          src="https://images.unsplash.com/photo-1542744095-fcf48d80b0fd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YWJvdXQlMjB1c3xlbnwwfHwwfHx8MA%3D%3D"
          alt="Work Culture"
          data-aos="fade-left"
        />

        <motion.div className="about-text-vm" data-aos="fade-right">
          <h2>Our Vision</h2>
          <p>
            Our vision is to build a world where every learner—no matter their background—can access meaningful, skill-driven, and life-changing education with a single click. We strive to become the global hub for practical learning, real experience, and endless opportunities, empowering students to grow into confident innovators, leaders, and professionals. At Acadme, we envision a future where learning never stops, possibilities never end, and every student finds the path that transforms their dreams into reality.
          </p>
          {/* <ul>
            <li> Inspires Impactful Innovation</li>
            <li> Encourages Personal Growth</li>
            <li> Work-Life Balance & Growth</li>
          </ul> */}
        </motion.div>
      </section>
    </div>
  );
}
